import { CardOnFileRow } from "@/features/patient/components/patient-details-drawer";
import { useCapturePhase } from "../hooks/useCapturePhase";
import { CardCapturePanel } from "./CardCapturePanel";
import { Spinner } from "@/components/ui/Spinner";
import { usePatientDetailsContext } from "@/features/patient/context/PatientDetailsContext";

const CardPanel = () => {
  const { patient, patientId } = usePatientDetailsContext();

  const fullName = patient
    ? `${patient.firstName ?? ""} ${patient.lastName ?? ""}`.trim()
    : "";

  const { captureState, markSuccess, handleCapture } = useCapturePhase({
    patientId: patientId!,
    enabled: !patient?.cardOnFile,
  });

  const render = () => {
    if (captureState.phase === "initializing") {
      return <Spinner />;
    }

    if (captureState.phase === "none" && patient?.cardOnFile) {
      return (
        <CardOnFileRow
          card={patient.cardOnFile}
          patientName={fullName}
          onDelete={() => {}}
        />
      );
    }

    return (
      <CardCapturePanel
        captureState={captureState}
        onSuccess={markSuccess}
        onRetry={handleCapture}
      />
    );
  };

  return <div className="px-5 pt-5 pb-6">{render()}</div>;
};

export default CardPanel;
